import appendQuery from 'append-query'
import { uniqueId } from 'lodash'
import { imagingUrl, jsonToFormData } from 'shared/api'
import { GET } from 'shared/util/fetch-methods'
import { SourceEditorEdits } from '../components/source-editor/types'
import getFileFromBase64 from './get-file-from-base64'

const IMAGING_API_BASE_URL = `${imagingUrl}/imaging`

const getEditedFile = async (source: File | string, endpoint: string, props: any = {}): Promise<File> => {
    let requestUrl = `${IMAGING_API_BASE_URL}${endpoint}`
    let requestData = GET

    if (typeof source === 'string') {
        requestUrl = appendQuery(requestUrl, {
            ...props,
            media_url: encodeURIComponent(source.replace(/(^\w+:|^)\/\//, '')),
        })
    } else {
        requestData = {
            method: 'POST',
            body: jsonToFormData({
                ...props,
                file: source,
            }),
        }
    }

    const blob = await fetch(requestUrl, requestData).then(response => response.blob())

    return new File([blob], uniqueId('asset'), {
        type: blob.type,
        lastModified: Date.now(),
    })
}

const getUploadWithEdits = async (source: File | string, edits?: SourceEditorEdits): Promise<File | string> => {
    if (!edits) {
        return source
    }

    const { trim, crop, watermarkUrl } = edits
    let currentFile: File | string = source

    if (trim) {
        currentFile = await getEditedFile(currentFile, `/trim`, {
            start: trim.start,
            duration: trim.end - trim.start,
            fmt: 'mp4',
        })
    }

    if (crop) {
        currentFile = await getEditedFile(currentFile, `/crop`, {
            x: crop.x,
            y: crop.y,
            width: crop.width,
            height: crop.height,
            fmt: 'mp4',
        })
    }

    if (watermarkUrl) {
        const watermarkFile = getFileFromBase64(watermarkUrl, 'image/png')

        currentFile = await getEditedFile(watermarkFile, `/watermark`, {
            media: currentFile,
            fmt: 'mp4',
        })
    }

    return currentFile
}

export default getUploadWithEdits
